import { Amplify } from 'aws-amplify';
import { generateClient } from 'aws-amplify/api';

const ONGOING_CALLS_ENDPOINT =
  process.env.REACT_APP_ONGOING_CALLS_APPSYNC_ENDPOINT;
const ONGOING_CALLS_REGION =
  process.env.REACT_APP_ONGOING_CALLS_APPSYNC_REGION;
const ONGOING_CALLS_API_KEY =
  process.env.REACT_APP_ONGOING_CALLS_APPSYNC_API_KEY;

if (!ONGOING_CALLS_ENDPOINT || !ONGOING_CALLS_REGION || !ONGOING_CALLS_API_KEY) {
  throw new Error(
    'Missing ongoing calls AppSync env vars. Set REACT_APP_ONGOING_CALLS_APPSYNC_ENDPOINT, REACT_APP_ONGOING_CALLS_APPSYNC_REGION, and REACT_APP_ONGOING_CALLS_APPSYNC_API_KEY.'
  );
}

Amplify.configure({
  API: {
    GraphQL: {
      endpoint: ONGOING_CALLS_ENDPOINT,
      region: ONGOING_CALLS_REGION,
      defaultAuthMode: 'apiKey',
      apiKey: ONGOING_CALLS_API_KEY
    }
  }
});

export const client = generateClient();
